import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";

const initialState = {
    isLoading: false,
    isResending: false,
    proccedPaymentData: {},
    updatePasswordData: {},
    errorMsg: "",
    isError: false
}

export const proccedPayment = createAsyncThunk('proccedPayment', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.proccedPayment(body);
        dispatch(setLoading(true))

        console.log(data,"data!--------");
        
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setProccedPayment(body))
                Toastify.success(data.message);
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const createFailedOrder=createAsyncThunk('createFailedOrder',async(body,{rejectWithValue, dispatch}) =>{
     

    try{

    const   {data,status} = await api.createdFailedOrder(body)

        if(status === 200){
            console.log("negetive order creation successfull");
            
        }
        return data.data
        
    } catch (err) {
        // Toastify.error(err.response.data.message);
        console.log(err);
        
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
    

})


export const paymentSlice = createSlice({
    name: "payments",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setProccedPayment: (state, action) => {
            state.proccedPaymentData = action.payload
        },
        
    },
    
})

export const { setLoading,setProccedPayment } = paymentSlice.actions

export default paymentSlice.reducer;